// Pages of wl-app the panel opens in a new tab, under `wlAppBaseUrl`.
export const WL_APP_CONNECTED_APPS_PATH = "/account/apps";
export const WL_APP_SKILLS_PATH = "/account/skills";
const WL_APP_PEOPLE_PATH = "/org/people";

export const wlAppSkillPath = (slug: string) => `${WL_APP_SKILLS_PATH}/${encodeURIComponent(slug)}`;

export const wlAppPersonPath = (memberId: string) => `${WL_APP_PEOPLE_PATH}/${encodeURIComponent(memberId)}`;
